module.exports = __webpack_public_path__ + "static/media/Jorah Mormont 2.f63f6ec2.jpg";